import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { defaults } from "../shared/defaults";
export const collectionSearchUrl = (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/${WiseConfig().LibraryId}/catalog/search?qs=${term}`;
const whiteLabel = {
    ...defaults,
    logo: ()=>/*#__PURE__*/ _jsx("img", {
            width: "231",
            height: "83",
            src: "/bkw/images/vbp/logo.svg",
            alt: "Het Virtueel Bibliotheek Platform",
            "aria-hidden": "true"
        }),
    collectionSearchUrl,
    loginUrl: ()=>`${WiseConfig().BaseUrl}/cgi-bin/bx.pl?var=portal;prt=INTERNET;taal=nl_NL;event=private;vestnr=${WiseConfig().LibraryId}`
};
export default whiteLabel;
